'use client'

import { formatters } from '@morpho-org/ui-v6/utils'

interface MetricTagClientProps {
  label: string
  value: number
}

export default function MetricTagClient({ label, value }: MetricTagClientProps) {
  const metricFormatted = formatters.commas.digits(0).unit('$').trailingZero(false).of(value)

  if (!metricFormatted) return null

  return (
    <div className="bg-popover dark:bg-muted border-border gap-xs px-md flex items-center rounded-2xl border-[0.5px] py-[5px] whitespace-nowrap shadow-sm dark:shadow-none">
      <span className="text-secondary-foreground text-xs !leading-none">{label}</span>
      <span className="text-foreground text-xs !leading-none">{metricFormatted}</span>
    </div>
  )
}
